module.exports = __webpack_public_path__ + "static/media/PasswordChange.0904e8d4.svg";